Wee.fn.make('biggestDiscounts', {
	init: function() {
        var scope = this;

        $.events.on({
            'ref:mobileFilter': {
                change: function(e) {
                    scope.filter(e.target.value);
                }
            },
            'ref:desktopFilter': {
                change: function(e) {
                    scope.filter(e.target.value);
                }
            }
        });
    },

    filter: function(cat) {
        var scope = this;

        Wee.$each('ref:filterPromo', function(el) {
            if (cat === 'all') {
                scope.showPromo(el);
            } else {
                if (cat === $(el).data('type')) {
                    scope.showPromo(el);
                } else {
                    scope.hidePromo(el);
                }
            }
        });
    },

    showPromo: function(el) {
        $(el).removeClass('-hidden');
    },

    hidePromo: function(el) {
        $(el).addClass('-hidden');
    }
});

Wee.biggestDiscounts.init();
